<template lang="pug">
  footer(id="footer" v-if="!loading")
    .desktop(:class="{ white: whiteFooter}")
      .grid
        .col-3
          button.subscribe.ag.bold.h-xl(:class="{ grey: whiteFooter}" @click="subscribe=true" aria-label="open newsletter subscribe modal")
            | join our newsletter
          .social
            a(href="https://www.facebook.com/caaminla" target="_blank" aria-label="Link to CAAM Facebook Page")
              figure
                img(:src="facebook" alt="facebook icon")
            a(href="https://twitter.com/caaminla" target="_blank" aria-label="Link to CAAM Twitter Page")
              figure
                img(:src="twitter" alt="twitter icon")
            a(href="https://www.instagram.com/caaminla/" target="_blank" aria-label="Link to CAAM Instagram Page")
              figure
                img(:src="insta" alt="instagram icon")
            a(href="https://www.youtube.com/channel/UCxbgXMDaQPRWeBxTd85HtFg" target="_blank" aria-label="Link to CAAM Youtube Page")
              figure
                img(:src="youtube" alt="youtube icon")
          button.covid-19(aria-label="Link to CDPH covid-19 Info Page")
            a(href="https://www.cdph.ca.gov/covid19" target="_blank")
              img(src="/static/icons/cdph-button.jpg" alt="CDPH icon")
          p.hours.body
            | <strong> Hours </strong> <br/>
            | Galleries Open <br/>
            | Tuesdays-Saturdays <br/>
            | 10:00 a.m.-5:00 p.m. <br/>
            | Sundays <br/>
            | 11:00 a.m.-5:00p.m.
        .col-9(:class="{ grey: subscribe}")
          .grid.nav.no-margin(v-if="!subscribe")
            .col-4(v-for="items in mapRoot()")
              ul
                li(v-for="item in items" )
                  router-link(:to="{ name: item.uid}")
                    h3.h-l
                      | {{ item.title }}
                  ul#subnav
                    li(v-for="child in item.children")
                      router-link.h-sx(
                        v-if="(item.uid !== 'exhibitions' && item.uid !== 'programs' && item.uid !== 'learn' && item.uid !== 'about')"
                        :to="{name: `${item.uid}-page`, params: { id: formatRoute(child.uid) }}"
                      )
                        | {{ child.title.toLowerCase()}}
                      router-link.h-sx(
                        v-if="item.uid === 'exhibitions'"
                        :to="{name: `${item.uid}`, query: { status: formatRoute(child.uid) }}"
                      )
                        | {{ child.title.toLowerCase()}}
                      router-link.h-sx(
                        v-if="item.uid === 'programs'"
                        :to="{name: `${item.uid}-overview`, params: { category: formatRoute(child.uid) }}"
                      )
                        | {{ child.title.toLowerCase() }}
                      router-link.h-sx(
                        v-if="item.uid === 'learn' && child.uid === '600state'"
                        :to="{name: 'blog'}"
                      )
                        | {{ child.title.toLowerCase() }}
                      router-link.h-sx(
                        v-else-if="item.uid === 'learn' && child.uid !== '600state'"
                        :to="{name: `${item.uid}-page`, params: { id: formatRoute(child.uid) }}"
                      )
                        | {{ child.title.toLowerCase() }}
                      router-link.h-sx(
                        v-else-if="(item.uid === 'about' && child.uid !== 'subscribe')"
                        :to="{name: `${item.uid}-page`, params: { id: formatRoute(child.uid) }}"
                      )
                        | {{ child.title.toLowerCase() }}
                      p.h-sx(v-else-if="(item.uid === 'about' && child.uid === 'subscribe')" @click="subs")
                        | {{ child.title.toLowerCase() }}
          .newsletter(v-if="subscribe")
            form(v-if="!message")
              fieldset
                legend.dn Subscribe to Newsletter
                span(v-show="errors.has('email')" class="help is-danger")
                  | {{ errors.first('email') }}
                label.dn(for="name") Email
                input(type="text", v-model="email", v-validate="'required|email'" :class="{'input': true, 'is-danger': errors.has('email') }", placeholder="email", name="email" title="Email")
                label.dn(for="firstname") First Name
                input(type="text", v-model="first", placeholder="first name" name="firstname" title="First Name")
                label.dn(for="lastname") Last Name
                input(type="text", v-model="last", placeholder="last name" name="lastname" title="Last Name")
                span(v-show="errors.has('zip')" class="help is-danger")
                  | {{ errors.first('zip') }}
                label.dn(for="zip") Zip
                input(type="text", v-model="zip", v-validate="'numeric'" :class="{'input': true, 'is-danger': errors.has('zip') }", placeholder="zip code", name="zip" title="Zip")
                button(type="button", @click="submit" aria-label="Subscribe to Newsletter")
                  | subscribe!
            .message(v-if="message")
              h2
                | {{ message }}
            .x(@click="xOut")
              visual(image="/static/icons/x_out.svg" alt="exit newsletter signup")
      .grid
        .col-3
          .logo-container
            #logo-bottom(v-if="!whiteFooter")
              visual(image="/static/logos/caam_logo_white.svg" alt="Caam Logo")
            #logo-bottom(v-if="whiteFooter")
              visual(image="/static/logos/caam_logo.svg" alt="Caam Logo")
        .col-9
          #slogan-bottom
            h4.free.h-l.lh-8(v-if="!subscribe" :class="{ white: whiteFooter}")
              | art. history. culture.
    .mobile(:class="{ white: whiteFooter}")
      button.subscribe.ag.bold.h-xl(
        @click="subscribe=true" aria-label="open newsletter subscribe modal"
        :class="{ grey: whiteFooter}"
      )
        | join our newsletter
      .newsletter.grey(v-if="subscribe")
        form(v-if="!message")
          fieldset
            legend.dn Subscribe to Newsletter
            span(v-show="errors.has('email')" class="help is-danger")
              | {{ errors.first('email') }}
            label.dn(for="email") Email
            input(type="text", v-model="email", v-validate="'required|email'" :class="{'input': true, 'is-danger': errors.has('email') }", placeholder="email", name="email" title="Email")
            span(v-show="errors.has('zip')" class="help is-danger")
              | {{ errors.first('zip') }}
            label.dn(for="zip") Zip
            input(type="text", v-model="zip", v-validate="'numeric'" :class="{'input': true, 'is-danger': errors.has('zip') }", placeholder="zip code", name="zip" title="Zip")
            button(type="button", @click="submit" aria-label="Subscribe to Newsletter")
              | subscribe!
            .message(v-if="message")
              h2
                | {{ message }}
            .x(@click="xOut")
              visual(image="/static/icons/x_out.svg" alt="exit newsletter signup")
      p.hours.body(:class="{ white: whiteFooter}")
        | <strong>Hours </strong><br/>
        | Galleries Open <br/>
        | Tuesdays-Saturdays 10:00 a.m.-5:00 p.m. <br/>
        | Sundays 11:00 a.m.-5:00 p.m.
      button.covid-19(aria-label="Link to CDPH covid-19 Info Page")
        a(href="https://www.cdph.ca.gov/covid19" target="_blank")
          img(src="/static/icons/cdph-button.jpg" alt="CDPH icon")
      h2.h-xxl.lh-8
        | California <br/>
        | African American <br/>
        | Museum
      p.address.body
        | 600 State Drive, Exposition Park, Los Angeles, CA 90037
      .social
        a(href="https://www.facebook.com/caaminla" target="_blank" aria-label="Link to CAAM Facebook Page")
          figure
            img(:src="facebook" alt="facebook icon")
        a(href="https://twitter.com/caaminla" target="_blank" aria-label="Link to CAAM Twitter Page")
          figure
            img(:src="twitter" alt="twitter icon")
        a(href="https://www.instagram.com/caaminla/" target="_blank" aria-label="Link to CAAM Instagram Page")
          figure
            img(:src="insta" alt="instagram icon")
        a(href="https://www.youtube.com/channel/UCxbgXMDaQPRWeBxTd85HtFg" target="_blank" aria-label="Link to CAAM Youtube Page")
          figure
            img(:src="youtube" alt="youtube icon")
</template>

<script>
import DataMixin from '@/mixins/DataMixin'
export default {
  name: 'bottom-nav',
  mixins: [DataMixin],
  props: ['footerColor'],
  data () {
    return {
      menu: false,
      active: null,
      subscribe: false,
      email: null,
      first: null,
      last: null,
      zip: null,
      message: false,
      roots: [],
      whiteFooter: false
    }
  },

  created () {
    this.requestData('root', 'root')
    this.whiteFooter = this.footerColor === 'white'
    window.addEventListener('resize', this.logoResize)
  },

  mounted () {
    let int = setInterval(() => {
      const lb = document.getElementById('logo-bottom')
      if (lb != null) {
        this.logoResize()
        clearInterval(int)
      }
    }, 50)
  },

  destroyed: function () {
    window.removeEventListener('resize', this.logoResize)
  },

  computed: {
    insta () {
      const l = '/static/icons/'
      return this.whiteFooter ? l + 'instagram.svg' : l + 'instagram_white.svg'
    },

    twitter () {
      const l = '/static/icons/'
      return this.whiteFooter ? l + 'twitter.svg' : l + 'twitter_white.svg'
    },

    youtube () {
      const l = '/static/icons/'
      return this.whiteFooter ? l + 'youtube.svg' : l + 'youtube_white.svg'
    },

    facebook () {
      const l = '/static/icons/'
      return this.whiteFooter ? l + 'facebook.svg' : l + 'facebook_white.svg'
    }
  },

  methods: {
    submit: function () {
      // const loc = window.location
      // const rootUrl = loc.protocol + '//' + loc.host
      // const url = rootUrl + '/api/newsletter/'
      const url = 'https://staging.caamuseum.org/api/newsletter'
      // const url = 'http://localhost:8888/caam/api/newsletter'
      const data = {
        email: this.email,
        first: this.first,
        last: this.last,
        zip: this.zip
      }

      this.post(url, data, response => {
        this.message = response.data.message
      })
    },

    logoResize: function () {
      const height = document.getElementById('logo-bottom').clientHeight
      document.getElementById('slogan-bottom').style.height = height + 'px'
    },

    xOut: function () {
      this.subscribe = false
      this.message = false
      this.email = null
      this.first = null
      this.last = null
      this.zip = null
    },

    rotate: function (matrix) {
      let result = []
      for (let i = 0; i < matrix[0].length; i++) {
        let row = matrix.map(e => e[i]).reverse()
        result.push(row)
      }
      return result
    },

    mapRoot: function () {
      let arr = this.loadedData.root
      // let length = 3
      let chunks = [[arr[0], arr[3], arr[6]], [arr[1], arr[4], arr[7]], [arr[2], arr[5]]]
      // let i = 0

      // while (i < arr.length) {
      //   // const indexOne = !arr[i] ? false : arr[i]
      //   // const indexTwo = !arr[length + i] ? false : arr[length + i]
      //   // const indexThree = !arr[(length * 2) + i] ? false : arr[(length * 2) + i]
      //   // chunks.push([indexOne, indexTwo, indexThree])
      //   chunks.push(arr.slice(i, i += length))
      // }
      // console.log('test', this.rotate(chunks))
      return chunks
    },

    formatRoute: function (item) {
      return item.replace(/ |'/g, '-').toLowerCase()
    }
  }
}

</script>

<style lang="sass">
@import '../styles/_variables'
@import '../styles/_mixins'
footer
  .grey
    background-color: rgba(255,255,255,0.95)
  .mobile
    display: none
    color: #FFF
    background-color: #000
    position: relative
    // height: 26rem
    &.white
      background-color: #FFF
      color: #636466
    @include respond-to(xs)
      display: block
    .subscribe
      padding-top: 1.7rem
      color: #FFF
      &.grey
        color: #636466
    .hours
      color: #FFF
      &.white
        color: #636466
    p
      padding-top: 2rem
      padding-bottom: 2rem
    .address
      padding-bottom: 0
    >*
      margin-left: 5%
      margin-right: 5%
    .social
      padding-bottom: 2rem
  .covid-19
    width: 50%
    min-width: 15rem
    margin-top: 4rem
    @include respond-to(xs)
      margin-bottom: 4rem
      width: 35vw
    img
      width: 100%
  .desktop
    background-color: #000
    margin-top: 8.8rem
    padding-top: 3rem
    color: #FFF
    height: auto
    @include respond-to(xs)
      height: unset
      display: none
    &.white
      background-color: #FFF
      color: #636466
    h3
      padding-left: 0
    .nav
      margin-top: 1rem
    .social
      display: flex
      justify-content: flex-start
      figure
        margin: 0
        margin-right: 10px
        margin-top: 1rem
        width: 20px
        img
          width: 100%
    .hours
      margin-top: 2.5em
    // #subnav
    //   a
    //     &:hover
    //       text-decoration: underline
  .subscribe
    cursor: pointer
    margin-top: 1rem
    border: none
    background: transparent
    color: #FFF
    &.grey
      color: #636466
  >ul
    position: absolute
    z-index: -1
  .newsletter
    margin-top: 11vH
    height: 72vH
    @include respond-to(xs)
      width: 100%
      height: 24.3rem
      margin: 0
      padding-top: 1.7rem
      position: absolute
      top: 0
    input, button
      text-align: left
      z-index: 999
      font-size: 3rem
      font-weight: 700
      margin-left: 9vW
      border: none
      margin-bottom: 2em
      @include respond-to(xs)
        font-size: 2rem
        margin-left: 5%
        margin-bottom: 2.2rem
    input[type="text"]
      width: 78%
      outline: 0
      border-bottom: solid 2px #000
      border-radius: 0
      background-color: rgba(255,255,255,0)
      color: black
      @include respond-to(xs)
        width: 82.5%
        margin-left: 5%
    fieldset
      margin: 0
      padding: 0
      border: none
    .dn
      display: none
    span
      width: 78%
      margin-left: 9vW
      font-size: 1.8rem
      color: red
      @include respond-to(xs)
        margin-left: 5%
        font-size: 1.2rem
    button
      display: block
      background: none
      padding: 0
      color: #000
      cursor: pointer
      border-bottom: solid 2px #000
      &:hover
        border-bottom: solid 2px #000
      @include respond-to(xs)
        margin-top: 4rem
    .vv-visual
      margin-left: 4rem
      width: 3rem
      cursor: pointer
      @include respond-to(xs)
        margin-left: 5%
        width: 2rem
  .message
    height: 44rem
    display: flex
    justify-content: center
    align-items: center
</style>



// WEBPACK FOOTER //
// BottomNav.vue?fa4251de